import { render } from "./NoResult.vue?vue&type=template&id=2ec48d7c&scoped=true"
import script from "./NoResult.vue?vue&type=script&lang=ts"
export * from "./NoResult.vue?vue&type=script&lang=ts"

import "./NoResult.vue?vue&type=style&index=0&id=2ec48d7c&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2ec48d7c"

export default script